import React, { useRef, useState, useEffect } from 'react';
import { Box } from '@mui/material';

const ScrollShadowBox = ({ children }: {
    children: React.ReactNode
}) => {
    const ref = useRef<HTMLDivElement>(null);
    const [ atTop, setAtTop ] = useState(true);
    const [ atBottom, setAtBottom ] = useState(false);

    const checkScroll = () => {
        if (!ref.current) {
            return;
        }
        const {
            scrollTop,
            scrollHeight,
            clientHeight,
        } = ref.current;
        setAtTop(scrollTop <= 0);
        setAtBottom(scrollTop + clientHeight >= scrollHeight - 1);
    };

    useEffect(() => {
        checkScroll();
        const el = ref.current;
        if (el) {
            el.addEventListener('scroll', checkScroll);
        }
        return () => {
            if (el) {
                el.removeEventListener('scroll', checkScroll);
            }
        };
    }, []);

    return (
        <Box sx={{
            position: 'relative',
            height: '100%',
        }}>
            <Box
                ref={ref}
                sx={{
                    height: '100%',
                    overflowY: 'auto',
                    pr: 1,
                }}
            >
                {children}
            </Box>

            {!atTop && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        height: 20,
                        background: 'linear-gradient(to bottom, rgba(0,0,0,0.2), transparent)',
                        pointerEvents: 'none',
                        zIndex: 1,
                    }}
                />
            )}

            {!atBottom && (
                <Box
                    sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: 20,
                        background: 'linear-gradient(to top, rgba(0,0,0,0.2), transparent)',
                        pointerEvents: 'none',
                        zIndex: 1,
                    }}
                />
            )}
        </Box>
    );
};

export default ScrollShadowBox;